import EventEmitter from '../utils/EventEmitter'

/**
 * Abtract Manager
 */
export default class AManager extends EventEmitter {
    preload (p5) {}

    setup (p5) {}

    draw (p5) {}
}



// WEBPACK FOOTER //
// ./webpack/js/abstracts/AManager.js